import { StepIndicatorItemViewModel } from './step-indicator-item.viewmodel';
import { StepModel } from './step-model.viewmodel';

export class AppStepIndicatorItemViewModel extends StepIndicatorItemViewModel<string> {
    constructor(stepInformationModel: StepModel) {
        super(
            stepInformationModel.stepId,
            stepInformationModel.title,
            stepInformationModel.visibility,
            stepInformationModel.disabledState,
            stepInformationModel.validity,
            stepInformationModel.touchedState
        );
    }
}
